import React from "react";
import styles from "./standard-token-window.module.scss";
import type { StandardTokenType } from "@/features/bridge/types/token-selector.types";
import { getTokenBackgroundColor } from "@/utils/token-color.util";

type Props = {
  symbol: StandardTokenType["symbol"];
  tokenAddress?: string;
};

const ImageFallbackPlaceholder = ({ symbol, tokenAddress }: Props) => {
  const colorConfig = getTokenBackgroundColor(tokenAddress, symbol);

  return (
    <div
      className={styles.imageFallbackPlaceholder}
      style={{ backgroundColor: colorConfig.backgroundColor }}
    >
      <div>{symbol || "Unknown"}</div>
    </div>
  );
};

export default ImageFallbackPlaceholder;
